import React from 'react';
import { Card, Skeleton } from 'antd';

import * as S from './styles';

export function Indicador({
  titulo = '',
  subTitulo = '',
  descricao = '',
  corTitulo = '',
  isLoading,
}) {
  return (
    <Card
      style={{
        borderRadius: '8px',
        border: 0,
        height: '100%',
      }}
    >
      <Skeleton
        loading={isLoading}
        active
        size="small"
        style={{
          padding: 0,
          margin: 0,
        }}
        paragraph={{ rows: 2 }}
      >
        <S.Title color={corTitulo}>{titulo || '0'}</S.Title>
        <S.SubTitle>{subTitulo || '00:00:00'}</S.SubTitle>
        <S.Description>{descricao}</S.Description>
      </Skeleton>
    </Card>
  );
}
